import { render, staticRenderFns } from "./AccountInfoItem.vue?vue&type=template&id=eb7645aa&"
import script from "./AccountInfoItem.ts?vue&type=script&lang=ts&"
export * from "./AccountInfoItem.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports